import Axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import LoadingBox from "../../Components/Loader";
import MessageBox from "../../Components/MessageBox";
import { detailsOrder, payOrder } from "../../store/actions/orderAction";
import { PayPalButton } from "react-paypal-button-v2";
import { ORDER_PAY_RESET } from "../../constants/orderConstants";
import { useParams } from "react-router-dom";
function OrderScreen(props) {
  const orderDetails = useSelector((state) => state.orderDetails);
  const orderPay = useSelector((state) => state.orderPay);
  const [sdkReady, setSdkReady] = useState(false);

  const { loading, error, order } = orderDetails;
  const {
    loading: loadingPay,
    error: errorPay,
    success: successPay,
  } = orderPay;

  const params = useParams();
  const { id: orderId } = params;

  const dispatch = useDispatch();


  useEffect(() => {
    const addPayPalScript = async () => {
      const { data } = await Axios.get("https://e-noon-web-api.herokuapp.com/api/config/paypal");
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = `https://www.paypal.com/sdk/js?client-id=${data}`;
      script.async = true;
      script.onload = () => {
        setSdkReady(true);
      };
      document.body.appendChild(script);
    };
    if (!order || successPay || (order && order._id !== orderId)) {
      dispatch({ type: ORDER_PAY_RESET })
      dispatch(detailsOrder(orderId));
    } else {
      if (!order.isPaid) {
        if (!window.paypal) {
          addPayPalScript();
        } else {
          setSdkReady(true);
        }
      }
    }
  }, [dispatch, order, orderId, sdkReady, successPay]);

  const successPaymentHandler = (paymentResult) => {
    dispatch(payOrder(order, paymentResult));
  };

  return loading ? (
    <LoadingBox></LoadingBox>
  ) : error ? (
    <MessageBox variant="danger">{error}</MessageBox>
  ) : (
    <div className="placeOrderContainer">
      <Container className="my-5">
        <Row className="mb-3">
          <Col md={12} xs={12}>
            <h3>Order: {order._id}</h3>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={8} className="">
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                  <button
                    className="accordion-button collapsed bg-transparent fs2"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    Shipping
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div className="accordion-body">
                    <div>
                      <span className="fs1 font-weight-bolder">Name: </span>
                      <span>{order.shippingAddress.fullName}</span>
                    </div>
                    <div>
                      <span className="fs1 font-weight-bolder">Address: </span>
                      <span>{order.shippingAddress.address}</span>
                    </div>
                    <div>
                      {order.isDelivered ? (
                        <MessageBox variant={"success"}>
                          Delivered At{order.deliveredAt}
                        </MessageBox>
                      ) : (
                        <MessageBox variant="danger">Not Delivered</MessageBox>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
                  <button
                    className="accordion-button collapsed bg-transparent fs2"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseTwo"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseTwo"
                  >
                    Payment
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseTwo"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingTwo"
                >
                  <div className="accordion-body">
                    <span className="fs1 font-weight-bolder">Method: </span>
                    <span>{order.paymentMethod}</span>
                    <div>
                      {order.isPaid ? (
                        <MessageBox variant={"success"}>
                          Delivered At{order.paiAt}
                        </MessageBox>
                      ) : (
                        <MessageBox variant="danger">Not paid</MessageBox>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingThree"
                >
                  <button
                    className="accordion-button bg-transparent fs2"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseTheree"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseTheree"
                  >
                    Order Items
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseTheree"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingTheree"
                >
                  <div className="accordion-body">
                    {order.orderItems.map((item, i) => {
                      return (
                        <Row key={i} className="my-3 align-items-center">
                          <Col xs={4} md={4}>
                            <img
                              width="80px"
                              src={item.image.map((img, i) => img.coverimg)}
                              alt="img"
                            />
                          </Col>
                          <Col xs={4} md={4}>
                            {item.name}
                          </Col>
                          <Col xs={4} md={4}>
                            {item.qty} x {item.price} = ${" "}
                            {item.qty * item.price}
                          </Col>
                        </Row>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={4}>
            <Card>
              <Card.Header className="text-center bg-warning" as="h5">
                Order Summary
              </Card.Header>
              <Card.Body>
                <div>
                  <span className="d-flex justify-content-between font-weight-bolder py-2">
                    <span>Items</span>
                    <span>{"$" + order.itemsPrice.toFixed(2)}</span>
                  </span>
                  <span className="d-flex justify-content-between font-weight-bolder py-2">
                    <span>Shipping</span>
                    <span>{"$" + order.shippingPrice.toFixed(2)}</span>
                  </span>
                  <span className="d-flex justify-content-between font-weight-bolder py-2">
                    <span>Tax</span>
                    <span>{"$" + order.taxPrice.toFixed(2)}</span>
                  </span>
                  <span className="d-flex justify-content-between font-weight-bolder py-2">
                    <h5>Order Total</h5>
                    <span>{"$" + order.totalPrice.toFixed(2)}</span>
                  </span>

                  {!order.isPaid && (
                    <span>
                      {!sdkReady ? (
                        <LoadingBox></LoadingBox>
                      ) : (
                        <>
                          {errorPay && (
                            <MessageBox variant="danger">{error}</MessageBox>
                          )}
                          {loadingPay && <LoadingBox></LoadingBox>}
                          <PayPalButton
                            amount={order.totalPrice}
                            onSuccess={successPaymentHandler}
                          ></PayPalButton>
                        </>
                      )}
                    </span>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default OrderScreen;
